// extracted by mini-css-extract-plugin
module.exports = {"inputCardWrapper":"input_card_inputCardWrapper__1FQhg","inputLabel":"input_card_inputLabel__E7JN1","input":"input_card_input__2Hwx9"};